import CustomButtton from "../Button/CustomButtton";
import {
  Framegroup,
  Groupsword,
  group,
  rightframe,
  screen,
  screengroup,
  screenhills,
  screentwo,
  threescreen,
  whitecard,
} from "../../images/general";
import React from "react";
import { Parallax } from "react-scroll-parallax";
import { Link } from "gatsby";
import { constants } from "../../utils/constants";
import { OutboundLink } from 'gatsby-plugin-gtag'

const FrouthSection = () => {

  return (
    <>
      <section className="bg-[#1F2327] pb-11 relative overflow-x-hidden overflow-y-hidden">
        <div className="text-center relative sm:pt-24 pt-14" 
                    data-sal="fade-out"
                    data-sal-delay="400"
                    data-sal-easing="ease">
          <img src={Groupsword} className="mx-auto pb-7 sm:w-max sm:h-max" />
          <h4 className="sm:text-2xl text-sm font-cinzel text-[#ACD6E9] font-bold leading-8 sm:pb-7 pb-5">
            The Gameplay
          </h4>
          <h3 className="sm:text-7xl text-[28px] font-cinzel text-white font-bold leading-7 smleading-[64px] sm:max-w-3xl sm:w-2/3 w-3/4 mx-auto uppercase">
            Explore the map & Choose your
          </h3>
          <h3 className="sm:text-7xl text-[28px] font-cinzel text-[#ACD6E9] font-bold leading-7 smleading-[64px] w-7/12 mx-auto  uppercase">
            territory
          </h3>
        </div>
        <div className="container max-w-7xl mx-auto px-4 sm:py-36 py-28" id="theStory">
          <div className="flex flex-col sm:flex-row">
            <div className="sm:w-5/12 2xl:w-7/12 ">
              <div className="relative">
                <img
                  src={screen}
                  className="mx-auto w-full hover:scale-y-110"
                  data-sal="slide-right"
                  data-sal-delay="400"
                  data-sal-easing="ease"
                />
                <img
                  src={screengroup}
                  className="absolute top-[105px] sm:-right-[123px] hover:scale-x-110"
                  data-sal="slide-up"
                  data-sal-delay="400"
                  data-sal-easing="ease"
                />
                <img
                  src={Framegroup}
                  className="absolute top-[215px] sm:-left-40 sm:w-max w-48"
                />
              </div>
            </div>
            <div
              className="lg:w-5/12 lg:pl-28 mt-32 sm:mt-5"
              data-sal="slide-left"
              data-sal-delay="400"
              data-sal-easing="ease"
            >
              <h2 className="sm:text-[56px] text-2xl font-cinzel text-white font-bold sm:leading-[48px] leading-6 lg:w-10/12 w-1/2 sm:text-left text-center sm:mx-0 mx-auto">
                <span className="text-[#E7D4C5]">Build</span> your empire
              </h2>
              <p className="sm:block hidden font-normal text-base leading-8 text-[#E7E7E7] py-8">
              Build your empire equipped with the essential buildings, upgrade for higher power and legacy. With the right strategy and perseverance, pave your path to become the most powerful empire in the Medieval times.
              </p>
              <p className="sm:hidden block font-normal text-base leading-8 text-[#E7E7E7] py-8 sm:text-left text-center">
              Build your empire equipped with the essential buildings, upgrade for higher power and legacy. With the right strategy and perseverance, pave your path to become the most powerful empire in the Medieval times. 
              </p>
              <div className="sm:w-max sm:mx-0 mx-auto w-4/5 sm:mb-3 mb-12 md:mb-0 shadow-customdivshadow ">
              <Link to={constants.app_routes.login}>
                <CustomButtton text="Build your empire" icon2={group} />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container max-w-7xl mx-auto px-4 sm:py-36 py-20" id="gamePlay">
          <div className="flex flex-col-reverse sm:flex-row">
            <div
              className="lg:w-5/12 lg:pr-28 mt-32 sm:mt-5"
              data-sal="slide-right"
              data-sal-delay="400"
              data-sal-easing="ease"
            >
              <h2 className="sm:text-[56px] text-2xl font-cinzel text-white font-bold sm:leading-[48px] leading-6 w-1/2 lg:w-full sm:text-left text-center sm:mx-0 mx-auto">
                <span className="text-[#E7D4C5]">Recruit</span> your forces
              </h2>
              <p className="sm:block hidden  font-normal text-base leading-8 text-[#E7E7E7] py-8">
              Recruit, train and enhance your army with a selection of brave heroes and soldiers. With the skillsets like archery, cavalry and sword fighting, choose the right army to launch attack on invaders to defend your empire.
              </p>
              <p className="sm:hidden block font-normal text-base leading-8 text-[#E7E7E7] py-8 sm:text-left text-center">
              Recruit, train and enhance your army with a selection of brave heroes and soldiers. With the skillsets like archery, cavalry and sword fighting, choose the right army to launch attack on invaders to defend your empire.
              </p>
              <div className="sm:w-max sm:mx-0 mx-auto w-4/5 sm:mb-3 mb-12 md:mb-0 shadow-customdivshadow ">
              <Link to={constants.app_routes.login}>
                <CustomButtton text="Recruit your forces" icon2={group} />
                </Link>
              </div>
            </div>
            <div className="sm:w-5/12 2xl:w-7/12 ">
              <div className="relative">
                <img
                  src={screentwo}
                  className="z-50 hover:scale-y-110"
                  data-sal="slide-left"
                  data-sal-delay="400"
                  data-sal-easing="ease"
                />
                <img
                  src={whitecard}
                  className="absolute sm:top-28 top-16 2xl:-right-16 right-16 sm:w-max w-72 hover:scale-x-110"
                  data-sal="slide-up"
                  data-sal-delay="400"
                  data-sal-easing="ease"
                />
                <img
                  src={rightframe}
                  className="absolute sm:top-[325px] top-[10.5rem] 2xl:-right-40 right-0 sm:w-max w-48"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container max-w-7xl mx-auto px-4 sm:py-36 sm:pb-36 pb-24 py-16" id="landLord">
          <div className="flex flex-col sm:flex-row">
            <div className="sm:w-5/12 2xl:w-7/12 ">
              <div className="relative">
                <img
                  src={threescreen}
                  className="mx-auto w-full hover:scale-y-110"
                  data-sal="slide-right"
                  data-sal-delay="400"
                  data-sal-easing="ease"
                />
                <img
                  src={screenhills}
                  className="absolute top-[105px] sm:-right-24 transform-x hover:scale-x-110"
                  data-sal="slide-up"
                  data-sal-delay="400"
                  data-sal-easing="ease"
                />
              </div>
            </div>
            <div
              className="lg:w-5/12 lg:pl-28 mt-32 sm:mt-5"
              data-sal="slide-left"
              data-sal-delay="400"
              data-sal-easing="ease"
            >
              {/* <h2 className="sm:block hidden  text-[56px] font-cinzel text-white font-bold leading-[48px] lg:w-10/12">
                Join <span className="text-[#E7D4C5]">millions</span> of players
              </h2> */}
              <h2 className=" sm:text-[56px] text-2xl font-cinzel text-white font-bold sm:leading-[48px] leading-6 lg:w-10/12 w-1/2 sm:text-left text-center sm:mx-0 mx-auto">
                <span className="text-[#E7D4C5]">Get </span>your Land
              </h2>
              <p className="sm:block hidden font-normal text-base leading-8 text-[#E7E7E7] py-8">
              Land owners in Medieval Empires can build their own empire by playing themselves and inviting other players to join them to build a better and stronger empire. The towns can also be rented out to other players who are willing to become a part of your empire's legacy. Land NFT's are available for you to start building your empire.
              </p>
              <p className="sm:hidden block font-normal text-base leading-8 text-[#E7E7E7] py-8 sm:text-left text-center">
              Land owners in Medieval Empires can build their own empire by playing themselves and inviting other players to join them to build a better and stronger empire. The towns can also be rented out to other players who are willing to become a part of your empire's legacy. Land NFT's are available for you to start building your empire.
              </p>
              <div className="sm:w-max sm:mx-0 mx-auto w-4/5 sm:mb-3 mb-12 md:mb-0 shadow-customdivshadow ">
                <OutboundLink href={constants.open_sea} target="_blank">
                <CustomButtton text="Get your land" icon2={group} />
                </OutboundLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FrouthSection;
